import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetAboutParams } from "../interface";
import LandingAbout from "design-system/src/Components/WidgetPart/LandingAbout/LandingAbout";

const LandingStandardAbout: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetAboutParams>((props) => {
    const { p } = props;

    return (
      <LandingAbout
        title={p("title") + ""}
        highlightedTitle={p("subtitle")}
        description={p("description")}
        imageId={p("image")}
        backgroundImage={{
          desktop: p("background_media_desktop"),
          mobile: p("background_media_mobile"),
        }}
        imageRight={p("image_position") === "image-right"}
        withoutImage={p("style_template") === "without-image"}
      />
    );
  });

export default LandingStandardAbout;
